module.exports = __webpack_public_path__ + "static/img/label-01.fb7aef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/label-01.png
// module id = Jl72
// module chunks = 31